// The rules a submit outcome applies to the screen's state, kept pure so they can be tested.

import type { FieldError } from '@glasses/shared'
import type { SubmitResult } from './data'

/**
 * What happens to the stored draft (PHI) once a submit settles, whether or not the screen is
 * still mounted. Only the outcomes the user is expected to retry keep it: a failed save (retry
 * with the same key) and an expired session (the sign-in redirect must not lose the form).
 * A saved order, field errors and a rejection all end with the form on screen or done with.
 */
export function draftAfter(result: SubmitResult): 'keep' | 'clear' {
  if (result.ok) return 'clear'
  return 'saveFailed' in result || 'sessionExpired' in result ? 'keep' : 'clear'
}

/**
 * The field errors to show after a submit: a validation result replaces them; any other outcome
 * clears them, so "Fix the highlighted fields" never sits beside an unrelated failure.
 */
export function errorsAfter(result: SubmitResult): FieldError[] | null {
  return !result.ok && 'errors' in result ? result.errors : null
}
